import React from 'react';
import { useLocation } from 'react-router-dom';
import Icon from 'components/commons/icon/Icon';
import Modal from './Modal';
import * as env from 'config/environment';
import { useRouting } from 'hooks/useRouting';
import { isApp } from '../utils/userStatus';

type PremiumModalProps = {
  onClose: () => void;
  layoutPattern: number;
};

// layoutPattern
// 1 -> 連携口座一覧', 2 -> '全体', 3 -> '不明', 4 -> '週次レポート', 5 -> 'ペルソナチャート', 6 -> 'ポートフォリオ　分散タブ', 7 -> '月次レポート'

const PremiumModal: React.FC<PremiumModalProps> = props => {
  const { pathname } = useLocation();
  const { onClose, layoutPattern } = props;

  const paramList = [
    {
      pattern: 1,
      param:
        'utm_source=tw_minkabu&utm_medium=securityaccountslink&utm_campaign=premium',
    },
    {
      pattern: 2,
      param: '',
    },
    {
      pattern: 3,
      param: '',
    },
    {
      pattern: 4,
      param: 'utm_source=tw_minkabu&utm_medium=modal&utm_campaign=weeklyreport',
    },
    {
      pattern: 5,
      param: '',
    },
    {
      pattern: 6,
      param: 'utm_source=tw_minkabu&utm_medium=modal&utm_campaign=diversified',
    },
    {
      pattern: 7,
      param:
        'utm_source=tw_minkabu&utm_medium=modal&utm_campaign=monthlyreport',
    },
  ];
  const param = paramList.find(list => list.pattern === layoutPattern)?.param;

  const linkDo = `${env.premiumURL}?service=${env.serviceName}&${
    param === undefined ? '' : param
  }&callback_url=${encodeURI(`${env.appURL}/auth?callbackPath=${pathname}`)}`;

  const linkLP = `${env.premiumLpURL}?service=${
    env.serviceName
  }&callback_url=${encodeURI(`${env.appURL}/auth?callbackPath=${pathname}`)}`;
  const linkLPTarget = `${env.appURL}/#target`;

  const routing = useRouting();
  const handlePremiumLp = (): void => {
    routing.pushRouting({ path: '/premiumLp' }, true);
  };

  const getLayout = (pattern: number): JSX.Element => {
    switch (pattern) {
      case 1:
        return (
          <img
            src={`/static/images/premium/premium1.png`}
            alt=""
            className="px-3"
          />
        );
      case 2:
        return (
          <>
            <img
              src="/static/images/premium/premium2.png"
              alt="資産目標サポート"
              className=""
            />
            <div className="mt-4 font-bold text-lg">
              老後や貯金は大丈夫？目標金額を貯めるためのサポートをします
            </div>
            <div className="flex flex-row items-center mt-3 text-base">
              <div className="icon-check text-white rounded-sm bg-teal-500"></div>
              <div className="ml-1">資産目標と進捗の見える化</div>
            </div>
            <div className="flex flex-row items-center mt-1 text-base">
              <div className="icon-check text-white rounded-sm bg-teal-500"></div>
              <div className="ml-1">安定した運用方法のアドバイス</div>
            </div>
            <div className="flex flex-row items-center mt-1 text-base">
              <div className="icon-check text-white rounded-sm bg-teal-500"></div>
              <div className="ml-1">進捗のレポートを毎月配信</div>
            </div>
            <div className="mt-2 mr-1 flex justify-end text-sm text-link">
              <a href={linkLPTarget} target="_blank" rel="noopener noreferrer">
                資産目標サポートとは？
                <Icon name="external-link" className="ml-1" />
              </a>
            </div>
          </>
        );
      case 3:
        return (
          <div className="mt-4">
            <img
              src={`/static/images/premium/premium3.png`}
              alt=""
              className="px-3"
            />
            <div className="mt-4 font-bold text-lg">
              資産状況を様々な角度からチャート化 してくれる便利なレポート機能！
            </div>
            <div className="mt-4">
              日・週・月と配信されるレポートをチェックするだけで資産の動きがわかり、今後の戦略がグッと立てやすくなります。
            </div>
          </div>
        );
      case 4:
      case 7:
        return (
          <div className="mt-4">
            <img
              src={`/static/images/premium/premium4.svg`}
              alt=""
              className="px-3"
            />
            <div className="mt-4 font-bold text-lg">
              １週間・１ヶ月の振返りができるレポート
            </div>
            <div className="mt-4">
              あなたの資産運用の改善点が見えてくる！「資産の確認をこまめにできない」忙しい人にもオススメです。
            </div>
          </div>
        );
      case 5:
        return (
          <div className="mt-2">
            <img
              src={`/static/images/premium/premium5.png`}
              alt=""
              className=""
              style={{ width: '350px', height: '180px' }}
            />
            <div className="mt-2 text-lg font-bold">
              他の会員や目標との比較ができる
              <br />
              リアルな情報がここにある
            </div>
            <div className="mt-2 text-base">
              アセプラ会員の年代や資産を数値化。
              <br />
              他の会員との比較をすることで現状の把握や世代ごとの資産総額を見て、自分の現状が把握できます。
            </div>
          </div>
        );
      case 6:
        return (
          <>
            <img
              src="/static/images/premium/premium6.svg"
              alt="ポートフォリオ"
              className="w-full"
            />
            <div className="mt-4 font-bold text-lg">
              分散投資できているかをチェック
            </div>
            <div className="mt-4 text-sm">
              安定した運用を続けるために重要な分散投資。
              ここでは、投資信託やロボアドの投資先も分析して、比率を確認できます。
            </div>
          </>
        );
      default:
        return <></>;
    }
  };

  const LayoutType1 = () => {
    return (
      <Modal closeOnClickOutside={true} onClose={onClose}>
        <div className="max-h-modal overflow-y-auto">
          <div className="flex pt-3 px-3">
            <div className="flex-grow" />
            <button onClick={onClose}>
              <Icon
                name="close"
                className="text-2xl text-gray-500 text-center"
              />
            </button>
          </div>
          <div className="mx-4 my-3">
            <div>ご利用には「みんかぶプレミアム会員」の登録が必要です。</div>
            {getLayout(layoutPattern)}
            <div className="mt-4 mr-1 flex justify-end text-link">
              {!isApp && (
                <a href={linkLP} target="_blank" rel="noopener noreferrer">
                  みんかぶプレミアムとは？
                  <Icon name="external-link" className="ml-1" />
                </a>
              )}
            </div>
            <div className="flex justify-center bg-red text-white rounded mx-1 mt-4 mb-2 p-3">
              {isApp ? (
                <div
                  onClick={handlePremiumLp}
                  className="flex flex-col items-center cursor-pointer">
                  <span className="font-bold">みんかぶプレミアムについて</span>
                </div>
              ) : (
                <a
                  href={linkDo}
                  target="_self"
                  className="flex flex-col items-center">
                  <span className="font-bold">
                    みんかぶプレミアムを試してみる
                  </span>
                  <span className="">初回30日間無料</span>
                </a>
              )}
            </div>
            <div
              className="flex justify-center text-gray-500 mx-1 my-2 p-2 cursor-pointer"
              onClick={onClose}>
              戻る
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  const LayoutType2 = () => {
    return (
      <Modal closeOnClickOutside={true} onClose={onClose}>
        <div className="max-h-modal overflow-y-auto">
          <div className="flex pt-3 px-3">
            <div className="flex-grow" />
            <button onClick={onClose}>
              <Icon
                name="close"
                className="text-2xl text-gray-500 text-center"
              />
            </button>
          </div>
          <div className="mx-4 mb-3">
            {getLayout(layoutPattern)}
            <div className="mt-6 text-sm">
              ご利用には「みんかぶプレミアム会員」の登録が必要です。
            </div>
            <div className="flex justify-center bg-red text-white rounded mx-1 mt-4 mb-2 p-3">
              {isApp ? (
                <div
                  onClick={handlePremiumLp}
                  className="flex flex-col items-center cursor-pointer">
                  <span className="font-bold">みんかぶプレミアムについて</span>
                </div>
              ) : (
                <a
                  href={linkDo}
                  target="_self"
                  className="flex flex-col items-center">
                  <span className="font-bold">
                    みんかぶプレミアムを試してみる
                  </span>
                  <span className="">初回30日間無料</span>
                </a>
              )}
            </div>
            <div className="mt-4 mr-1 flex justify-center text-sm text-link">
              {!isApp && (
                <a href={linkLP} target="_blank" rel="noopener noreferrer">
                  みんかぶプレミアムとは？
                  <Icon name="external-link" className="ml-1" />
                </a>
              )}
            </div>
            <div
              className="flex justify-center text-sm text-gray-500 mx-1 my-2 p-2 cursor-pointer"
              onClick={onClose}>
              戻る
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  if (layoutPattern === 2 || layoutPattern === 6) {
    return <LayoutType2 />;
  } else {
    return <LayoutType1 />;
  }
};

export default PremiumModal;
